import { create } from 'zustand'

/**
 * Global open-state for the new-booking panel (spec/clubmanager/15 BR-17 — the dock
 * "Reserva" action + the ⌘K "Nueva reserva" entry). Mirrors
 * `useQuickSaleStore`: a tiny boolean so the bottom dock and the command
 * palette can open the **one** shared `BookingFormPanel` (create mode)
 * from any screen — no per-page state, no navigation hop. The panel is
 * mounted once in app-shell; this only carries the flag.
 *
 * Fixes the asymmetry where "Reserva" merely navigated to Hoy while
 * "Venta" opened its panel inline.
 */
interface QuickBookingState {
  open: boolean
  openQuickBooking: () => void
  closeQuickBooking: () => void
}

export const useQuickBookingStore = create<QuickBookingState>((set) => ({
  open: false,
  openQuickBooking: () => set({ open: true }),
  closeQuickBooking: () => set({ open: false }),
}))
